import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const ML = ({ branch = "AIML", semester = "4th Semester" }) => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Introduction to Machine Learning- Basic concepts, developing a learning system, Learning
        Issues, and challenges. Types of Machine Learning. Feature Selection Mechanisms, Imbalanced
        Data, Bias in Data, Outlier Detection</p>
    </div>,
    <div key="2" className="p-4">
      <p>Supervised Learning- Linear Regression, Multiple Regression, Logistic Regression,
        Classification; Classifier Models, K Nearest Neighbor (KNN), Naive Bayes, Decision Trees,
        Support Vector Machine (SVM), Random Forest</p>
    </div>,
    <div key="3" className="p-4">
      <p>Unsupervised Learning- Dimensionality Reduction; Clustering; K-Means Clustering; C-Means
        Clustering; Fuzzy C Means Clustering, Association Analysis- Association Rules in Large
        Databases, Association rules mining, Apriori Algorithm, Markov Models: Hidden Markov Models (HMMs).</p>
    </div>,
    <div key="4" className="p-4">
      <p>Reinforcement Learning- Introduction to Reinforcement Learning, Elements of Reinforcement
        Learning, Approaches to Reinforcement Learning, Applications of Reinforcement learning.
        Applications of Machine Learning in different sectors: Medical Diagnostics, Fraud Detection,
        Email Spam Detection.</p>
    </div>
  ];

  const tabData = [
    { id: 'syllabus', label: 'Syllabus', content: null },
    { id: 'notes', label: 'Notes', content: null },
    { id: 'important', label: 'Important Questions', content: null },
    { id: 'books', label: 'Books', content: null },
    { id: 'PYQ', label: 'PYQ', content: null },
    { id: 'youtube_playlist', label: 'Video Lectures', content: null },
  ];

  return (
    <SubjectPage
      subjectName="Machine Learning"
      subjectKey="AI_ML"
      branch={branch}
      semester={semester}
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'MLNotes',
        videos: 'MLVideos'
      }}
    />
  );
};

export default ML;